import React from 'react';
import { emojiCharacterToIconComponent } from './emojiIconMap';

export interface EmojiProps {
  emoji: string;
  width?: number;
  height?: number;
}

export const Emoji: React.FC<EmojiProps> = ({ emoji, width, height }) => {
  const IconComponent = emojiCharacterToIconComponent[emoji];

  if (!IconComponent) {
    return <span style={{ fontFamily: "'Noto Color Emoji', sans-serif" }}>{emoji}</span>;
  }

  // SVG height needs to match font fallback height (which includes line-height)
  // Font fallback height is approximately 1.3125x the font-size
  const adjustedHeight = height ? Math.round(height * 1.3125) : height;

  return <IconComponent width={width} height={adjustedHeight} />;
};
